import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { Card, CardContent } from '../ui/card';
import { cn } from '../../lib/utils';

export function StepperSection({ steps, current, className }) {
  const currentIndex = steps.findIndex((step) => step.id === current);
  return (
    <Card className={cn('border-slate-200 bg-white shadow-sm', className)}>
      <CardContent className="p-3">
        <ol className="flex items-center">
          {steps.map((step, index) => {
            const Icon = step.icon;
            const isCompleted = currentIndex > -1 && index < currentIndex;
            const isActive = index === currentIndex;
            return (
              <React.Fragment key={step.id}>
                {index > 0 && (
                  <li aria-hidden="true" className={cn('mx-3 h-px flex-1', isCompleted ? 'bg-emerald-300' : 'bg-slate-200')} />
                )}
                <li className="flex items-center gap-2.5">
                  <span
                    className={cn(
                      'relative grid h-8 w-8 shrink-0 place-items-center rounded-full',
                      isActive && 'bg-emerald-600 text-white shadow-sm',
                      !isActive && isCompleted && 'bg-emerald-100 text-emerald-700',
                      !isActive && !isCompleted && 'bg-slate-100 text-slate-500'
                    )}
                  >
                    <Icon className="h-4 w-4" />
                    {isCompleted && (
                      <CheckCircle2 className="absolute -right-1.5 -top-1.5 h-4 w-4 rounded-full bg-white text-emerald-600" />
                    )}
                  </span>
                  <span
                    className={cn(
                      'text-sm',
                      isActive ? 'font-semibold text-slate-900' : isCompleted ? 'font-medium text-slate-600' : 'text-slate-500'
                    )}
                  >
                    {step.label}
                  </span>
                </li>
              </React.Fragment>
            );
          })}
        </ol>
      </CardContent>
    </Card>
  );
}
